<template>
  <v-card class="mr-3 ml-3 mb-3">
    <v-card>
        <v-row>
        <v-col cols="6" style="padding-right: 0px !important;">
        <v-card min-height="200" class="mx-2">
            <v-card-title>
              <span class="headline">Выбрать период построения отчета</span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-row>
                <v-col cols="10" class="pb-0">
                  <div class="d-flex justify-space-between flex-wrap">
                    <v-btn
                      class="mb-4"
                      color="green"
                      dark
                      small
                      @click="setTodayFilter"
                      >Сегодня
                    </v-btn>
                    <v-btn
                      class="mb-4"
                      color="green"
                      dark
                      small
                      @click="setWeekFilter"
                      >+- Неделя
                    </v-btn>
                    <v-btn
                      class="mb-4"
                      color="green"
                      dark
                      small
                      @click="setMonthFilter"
                      >+- Месяц
                    </v-btn>
                    <v-btn
                      class="mb-4"
                      color="primary"
                      dark
                      small
                      @click="setNoFilter"
                      >Всё время
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <template>
                <v-row>
                  <v-col cols="4" sm="4" class="py-0">
                    <v-menu
                      v-model="dateFromMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateFromFormatted"
                          label="Начало периода"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          @blur="date = parseDate(dateFromFormatted)"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateFrom"
                        no-title
                        @input="dateFromMenu = false"
                        :first-day-of-week="1"
                        locale="ru-RU"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col  cols="4" sm="4" class="py-0">
                    <v-menu
                      v-model="dateToMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateToFormatted"
                          label="Конец периода"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          @blur="date = parseDate(dateToFormatted)"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateTo"
                        no-title
                        @input="dateToMenu = false"
                        :first-day-of-week="1"
                        locale="ru-RU"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
          </v-col>
          <v-col cols="6" style="padding-left: 0px !important">
            <v-card min-height="200" class="mx-2">
              <v-card-title>
                <span class="headline">Выбрать ЮЛ</span>
              </v-card-title>
              <v-card-text>
                  <v-virtual-scroll height="110" item-height="40" :items="entity_list">
                    <template v-slot:default="{item}">
                      <v-list-item :key="'entity_'+item.id">
                        <v-checkbox 
                        :key="'entity_' + item.id" 
                        :label="item.name" 
                        v-model="money_for_filter"
                        :value="item.id"></v-checkbox>
                      </v-list-item>
                    </template>
                  </v-virtual-scroll>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card-actions>
            <v-menu v-if="this.$store.getters.user.roleId === 0" class="mr-3" color="green" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                <v-icon>mdi-file-download</v-icon>
                Выгрузить в файл
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportToFile('csv')">csv</v-list-item>
              <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>        
            <v-btn color="primary darken-1" text @click="filterLogs"
                      >Применить</v-btn
                    >
        </v-card-actions>
      </v-card>
    <v-card-title class="headline justify-space-between">
      <v-spacer></v-spacer> 
      <div>
        <v-text-field
          v-if="$store.getters.dealers"
          v-model="search"
          append-icon="mdi-magnify"
          label="Поиск"
          single-line
          hide-details
          class="pt-0"
        ></v-text-field>
      </div>
    </v-card-title>

    <v-data-table
      class="mb-3 mx-3"
      :search="search"
      :headers="headers"
      :items="logsFiltered"
      :item-class="() => 'clickable-row'"
      sort-by="licExpires"
      no-data-text="Пусто"
      no-results-text="Результатов нет"
      hide-default-footer
      :custom-sort="customSort"
      @click:row="editLicense"
      :loading="tableLoading"
      loading-text="Загрузка"
      :items-per-page="-1"
    >
      <template v-slot:item.objectName="{ item }">
        <span
          class="clickable-item"
          @click.stop="$router.push(`/objects/${item.objectId}`)"
          >{{ item.objectName }}</span
        >
      </template>
      <template v-slot:item.dealerName="{ item }">
        <span
          class="clickable-item"
          @click.stop="$router.push(`/dealers/${item.dealerId}`)"
          >{{ item.dealerName }}</span
        >
      </template>
      <template v-slot:item.licExpires="{ item }">
        <span
          :class="{
            expired:
              new Date(new Date().toISOString().slice(0, 10)) >
              new Date(item.licExpires),
          }"
        >
          <v-badge v-if="item.isSosActivated" color="red" content="SOS">{{
            new Date(item.licExpires).toLocaleDateString()
          }}</v-badge>
          <template v-else>{{
            new Date(item.licExpires).toLocaleDateString()
          }}</template>
        </span>
      </template>
      <template v-slot:item.moneyFor="{ item }">
          <span v-if="item.showroom">Никому, это шоурум</span>
          <span v-else-if="item.moneyFor != null && $store.getters.mappedOurLegalEntities[item.moneyFor]">{{
            $store.getters.mappedOurLegalEntities[item.moneyFor].name }}</span>
          <span v-else>Не задано</span>
      </template>
      <template v-slot:item.masterExpires="{ item }">
        <span
          :class="{
            expired:
              new Date(new Date().toISOString().slice(0, 10)) >
              new Date(item.masterExpires),
          }"
          >{{ new Date(item.masterExpires).toLocaleDateString() }}</span
        >
      </template>
      <template v-slot:item.toMaster="{ item }">
        <v-icon @click.stop="$router.push(`/masters/${item.masterId}`)">
          mdi-open-in-new
        </v-icon>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :pagination="pagination"
          :options="options"
          @update:options="updateOptions"
          :items-per-page-options="[10, 50, 100, -1]"
          items-per-page-text="$vuetify.dataTable.itemsPerPageText"
        />
      </template>
      <template v-slot:item.updateTime="{ item }">
        <span>{{ formatUpdateTime(item.updateTime) }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import API from "@/axios/api";
import FormatDateTime from "@/utils/time.js";

export default {
  data() {
    return {
      periodDialog: false,

      dateFromMenu: false,
      dateFrom: null,
      dateFromFormatted: "",

      dateToFormatted: "",
      dateTo: null,
      dateToMenu: false,

      entity_list: [],
      money_for_filter: [],

      tableLoading: true,
      search: "",
      logs: [],
      logsFiltered: [],
      headers: [
        {
          text: "#",
          align: "start",
          value: "id",
        },
        {
          text: "Объект",
          align: "start",
          value: "objectName",
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
        },
        {
          text: "Модуль ПО",
          align: "start",
          value: "moduleName",
        },
        {
          text: "Деньги кому?",
          align: "start",
          value: "moneyFor",
          sortable: false,
        },
        {
          text: "Lic Date",
          align: "center",
          value: "licExpires",
        },
        {
          text: "Max Date",
          align: "center",
          value: "masterExpires",
        },
        {
          text: "Изменил",
          align: "center",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Мастер",
          align: "center",
          value: "toMaster",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    dateFrom() {
      this.dateFromFormatted = this.formatDate(this.dateFrom);
    },
    dateTo() {
      this.dateToFormatted = this.formatDate(this.dateTo);
    },
    dateFromFormatted() {
      this.dateFrom = this.parseDate(this.dateFromFormatted);
    },
    dateToFormatted() {
      this.dateTo = this.parseDate(this.dateToFormatted);
    },
  },
  methods: {
    exportToFile(format) {
          API.get(`licenses/licenses_reports?format=${format}&entity=${JSON.stringify(this.money_for_filter)}
          &from=${this.dateFrom}&to=${this.dateTo}`, { responseType: 'blob' })
          .then(response => {
          if (response.status === 200) {
            let contentType = '';
            let fileExtension = '';
            if (format === 'csv') {
              contentType = 'text/csv';
              fileExtension = '.csv';
            } else if (format === 'xlsx') {
              contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              fileExtension = '.xlsx';
            }
            const blob = new Blob([response.data], { type: contentType });
            const date = new Date();
            const currentDate = this.formatUpdateTime(date); 
            const filename = `Отчет Наши ЮЛ ${currentDate}${fileExtension}`.replace(/:/g, '.');
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            }
            console.log('Файл успешно загружен');
          } else {
            console.error('Ошибка загрузки файла:', response.statusText);
          }
        })
        .catch(error => {
          console.error('Ошибка загрузки файла:', error);
        });
    },
    customSort(items, index, isDesc) {
      if (index[0] === "licExpires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.licExpires) > new Date(b.licExpires) ? 1 : -1;
          } else {
            return new Date(a.licExpires) > new Date(b.licExpires) ? -1 : 1;
          }
        });
      } else if (index[0] === "masterExpires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.masterExpires) > new Date(b.masterExpires)
              ? 1
              : -1;
          } else {
            return new Date(a.masterExpires) > new Date(b.masterExpires)
              ? -1
              : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    setTodayFilter() {
      this.dateFrom = this.getIsoDate(new Date());
      this.dateTo = this.getIsoDate(new Date());
    },
    setWeekFilter() {
      // this.dateFrom = this.getIsoDate(new Date(new Date().setDate(new Date().getDate() - 7)));
      this.dateFrom = this.getIsoDate(new Date());
      this.dateTo = this.getIsoDate(
        new Date(new Date().setDate(new Date().getDate() + 7))
      );
    },
    setMonthFilter() {
      this.dateFrom = this.getIsoDate(
        new Date(new Date().setMonth(new Date().getMonth() - 1))
      );
      this.dateTo = this.getIsoDate(
        new Date(new Date().setMonth(new Date().getMonth() + 1))
      );
    },
    setNoFilter() {
      this.dateFrom = this.getIsoDate(new Date(0));
      this.dateTo = this.getIsoDate(new Date(Date.UTC(2100, 0, 1)));
    },
    filterLogs() {
      this.periodDialog = false;
      let tempDateFrom = new Date(
        this.dateFrom.split("-")[0],
        parseInt(this.dateFrom.split("-")[1]) - 1,
        this.dateFrom.split("-")[2]
      );
      let tempDateTo = new Date(
        this.dateTo.split("-")[0],
        parseInt(this.dateTo.split("-")[1]) - 1,
        this.dateTo.split("-")[2],
        23,
        59,
        59
      );

      this.logsFiltered = this.logs.filter((log) => {
        let tempDate = new Date(log.licExpires);
        let moneyFor = log.moneyFor;
        return tempDate >= tempDateFrom &&
               tempDate <= tempDateTo &&
               (this.money_for_filter.length === 0 || (this.money_for_filter.length !== 0 && this.money_for_filter.includes(moneyFor)));
      });
    },
    getIsoDate(date) {
      return date.toISOString().substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    editLicense(license) {
      this.$router.push("/licenses/" + license.id);
    },
    async getLicenses() {
      await API.get("licenses/report")
        .then((response) => {
          console.log(response.data);
          this.logs = response.data.licenses;
          this.filterLogs();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch("updateMappedOurLegalEntities"),
    ])
    this.entity_list = Object.values(this.$store.getters.mappedOurLegalEntities)
    this.entity_list.push({id: null, name: "Не задано"})
  },
  activated() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "reports", disabled: true },
      { text: "licenses", disabled: true },
    ]);
    this.getLicenses().then(() => {
      this.tableLoading = false;
    });
  },
  created() {
    this.setWeekFilter();
  },
};
</script>

<style>
.clickable-item {
  background-color: #d5e9d4;
  padding: 0.2rem 0.5rem;
  border-radius: 5px;
  cursor: pointer;
}

.expired {
  background-color: #eccdcd;
  color: #000000;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}

.v-data-footer {
  border-top: none !important;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
</style>
